export const isYouTubeUrl = (rawUrl) => {
  if (!rawUrl) {
    return false;
  }

  try {
    const parsedUrl = new URL(rawUrl);
    const hostname = parsedUrl.hostname.replace(/^www\./, "");

    const isYouTubeHost =
      hostname === "youtube.com" ||
      hostname.endsWith(".youtube.com") ||
      hostname === "youtu.be";

    if (!isYouTubeHost) {
      return false;
    }

    if (hostname === "youtu.be") {
      return parsedUrl.pathname.length > 1;
    }

    const hasVideoId =
      parsedUrl.searchParams.has("v") ||
      parsedUrl.pathname.startsWith("/shorts/") ||
      parsedUrl.pathname.startsWith("/live/") ||
      parsedUrl.pathname.startsWith("/embed/");

    return hasVideoId;
  } catch (error) {
    return false;
  }
};

/** `endpoint` scoped to an agency with `?agency_id=` (the superadmin's way to pick one); unchanged without it. */
export const withAgencyParam = (endpoint, agencyId) => (agencyId ? `${endpoint}?agency_id=${agencyId}` : endpoint);

/** Downloads a file by URL; media without CORS opens in a new tab so the browser offers to save it. */
export const downloadImage = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(response.statusText);
    const objectUrl = URL.createObjectURL(await response.blob());
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = url.split("/").pop();
    link.click();
    URL.revokeObjectURL(objectUrl);
  } catch {
    window.open(url, "_blank", "noopener");
  }
};
